import { useState, useCallback } from 'react';
import { firebaseAuth } from '@/lib/firebase';
import { authContainer } from '../../di/container';

/**
 * Reenvia o e-mail de verificação **pelo back** (`POST /auth/send-verification`),
 * não pelo SDK do Firebase — o link tem que ser o nosso (`/verify-email?token=`).
 * `send(email?)`: se o e-mail não for passado, usa o do usuário logado (ex.: botão
 * "reenviar" no perfil); o muro de verificação passa o e-mail explicitamente.
 */
export function useSendVerification() {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const send = useCallback(async (email?: string) => {
    const target = email ?? firebaseAuth.currentUser?.email ?? undefined;
    if (!target) return;
    setIsLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await authContainer.repository.sendVerification(target);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao enviar e-mail');
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { send, isLoading, success, error };
}
